import React, { useState, useEffect } from "react";
/** Components Import */
import { Button, ButtonGroup as BootstrapButtonGroup } from "react-bootstrap";

function ButtonGroup({
  className = "",
  size = "md", // 'sm' | 'md' | 'lg'
  vertical = false,
  items = [],
}) {
  return (
    <BootstrapButtonGroup className={className} size={size} vertical={vertical}>
      {items.map((item, index) => {
        return <React.Fragment key={index}>{item}</React.Fragment>;
      })}
    </BootstrapButtonGroup>
  );
}

export default ButtonGroup;
